import { gql } from '@apollo/client'

export const UPDATE_REFERENCE_PYRAMIDS = gql`
  mutation UpdateReferencedPyramids($referencePyramidInput: ReferencePyramidInput!) {
    updateReferencedPyramids(referencePyramid: $referencePyramidInput) {
      id
    }
  }
`

export const DELETE_REFERENCE_PYRAMID = gql`
  mutation DeleteReferencedPyramids($referencePyramidId: HashedId!, $companyId: HashedId!) {
    deleteReferencedPyramids(referencePyramidId: $referencePyramidId, companyId: $companyId) {
      id
    }
  }
`

export const SAVE_PYRAMID_FORECAST = gql`
  mutation SavePyramidForecast($companyId: HashedId!, $pyramidForecasts: [PyramidForecastInput!]!) {
    savePyramidForecast(companyId: $companyId, pyramidForecasts: $pyramidForecasts) {
      id
      forecastId
      newHiringFullName
      businessUnitId
      salary
      bonus
      age
      levelChange
      dateOfLevelChange
      forecastDate
      forecastEndDate
      companyId
      employeeId
    }
  }
`
